var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpendingOnboardingUserCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 80,
    viewBox: "0 0 102 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2355_45112)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.3867,
    y: 11.5963,
    width: 64,
    height: 40,
    rx: 6,
    transform: "rotate(4 22.3867 11.5963)",
    fill: "#EE4266"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.3867,
    y: 7.59631,
    width: 64,
    height: 40,
    rx: 6,
    transform: "rotate(4 18.3867 7.59631)",
    fill: "#255B8F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.2387,
    cy: 19.8173,
    r: 6,
    transform: "rotate(4 29.2387 19.8173)",
    fill: "#97D5FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.2197,
    cy: 20.3753,
    r: 6,
    transform: "rotate(4 37.2197 20.3753)",
    fill: "#FFFEFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5423 15.636C34.69 16.8175 35.35 18.4638 35.226 20.2364C35.102 22.0084 34.2193 23.5457 32.9188 24.5559C31.7714 23.3744 31.112 21.7289 31.2359 19.9566C31.3599 18.1843 32.2415 16.6463 33.5423 15.636Z",
    fill: "#489FD9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.061,
    y: 25.0532,
    width: 12,
    height: 12,
    rx: 2,
    transform: "rotate(4 61.061 25.0532)",
    fill: "#E8C284"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2355_45112",
    x: 0,
    y: 0,
    width: 101.827,
    height: 79.5596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.0509804 0 0 0 0 0.14902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2355_45112"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.0862745 0 0 0 0 0.211765 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2355_45112",
    result: "effect2_dropShadow_2355_45112"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2355_45112",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendingOnboardingUserCard);
export default __webpack_public_path__ + "static/media/spending-onboarding-user-card.22aecc3a8d2dee6b596aee50cba29fef.svg";
export { ForwardRef as ReactComponent };